import { useEffect } from 'react';
import { App } from 'antd';
import { setNotificationMessageApi } from './showNotificationMessage';

/** Bridges App.useApp().message into showNotificationMessage for non-React callers (redux, etc.). */
export const AntdAppMessageBridge = () => {
  const { message } = App.useApp();

  useEffect(() => {
    setNotificationMessageApi(message);
    return () => setNotificationMessageApi(null);
  }, [message]);

  return null;
};
